import React from "react";
import { Segment, Header } from "semantic-ui-react";
import { Field } from "redux-form";

function OpcionesAdicionales({ opcionAgosto }) {
  return (
    <Segment>
      <Header as="h3">Otras Opciones:</Header>
      <div>
        <label>
          <Field
            id="opcionAgosto"
            name="opcionAgosto"
            type="checkbox"
            component="input"
          />
          {` ${opcionAgosto.nombre}`}

        </label>
      </div>
    </Segment>
  );
}

export default OpcionesAdicionales;



// WEBPACK FOOTER //
// ./src/pages/inscripciones/hojaInscripcion/formularioInscripcion/OpcionesAdicionales.jsx